// eslint-disable-next-line boundaries/external
import { createCookie, redirect } from "react-router";
import { getQuery } from "ufo";

const AFF_COOKIE_NAME = "aff_integration";

export const affCookie = createCookie(AFF_COOKIE_NAME, {
  maxAge: 60 * 60 * 24 * 30, // 1 месяц
  httpOnly: false,
});

export const makePlayNowUrl = (aff?: string): string =>
  `https://xingyunpuke.com/${aff ? `?qtag=${aff}` : ""}`;

export const getAffCookie = async (
  req: Request,
): Promise<string | undefined> => {
  const cookieHeader = req.headers.get("Cookie");
  const result = await affCookie.parse(cookieHeader);

  return typeof result === "string" ? result : undefined;
};

export const createAffCookie = async (
  req: Request,
): Promise<string | undefined> => {
  const existedCookie = await getAffCookie(req);

  if (existedCookie) {
    return undefined;
  }

  const affTag = getQuery(req.url).qtag;
  if (typeof affTag !== "string") {
    return undefined;
  }

  const cookie = await affCookie.serialize(affTag);

  throw redirect(req.url, {
    headers: {
      "Set-Cookie": cookie,
    },
  });
};
